export default "__VITE_ASSET__28a8d98e__"